// the styles here, so that they stay in the HTML and the page never shows unstyled
import 'leaflet/dist/leaflet.css';
import './ds/tokens/colors.css';
import './ds/brands/terrainavendre.css';
import './ds/brands/bienavendre.css';
import './ds/brands/bienalouer.css';
import './ds/tokens/spacing.css';
import './ds/tokens/typography.css';
import './ds/patterns.css';
import './ds/brands/sister-patterns.css';
import './app.css';
import './list.css';
import './build.css';
import { boot } from './lib/boot.js';

boot(() => import('./main.jsx'));
